import {FormModel} from "./form.model.abstract";
import {ValidatorFn} from "@angular/forms";

/**
 * Combined field of two text fields and one select field.
 * @inheritDoc
 */
export class FormModelDoubleTextSelect extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'doubletext-select';

  /**
   * @inheritDoc
   * @param id
   * @param secondId The id of the second text field.
   * @param selectId The id of the select field.
   * @param unit
   * @param secondUnit The unit of the second text field.
   * @param validators
   * @param options List of options for the select field.
   * @param values
   * @param info
   * @param fieldType
   */
  constructor(id: string, secondId: string, selectId: string, unit: string, secondUnit: string, validators: ValidatorFn[] = [], options: string[], values: string[] = [], info: boolean = true, fieldType: string = 'text') {
    super(id, validators, null, null, info);

    this.options = options;
    this.unit = unit;
    this.secondUnit = secondUnit;
    this.fieldData["secondId"] = secondId;
    this.fieldData["selectId"] = selectId;
    this.fieldData["fieldType"] = fieldType;
    this.fieldData["values"] = values;
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelDoubleTextSelect {
    // @ts-ignore
    return new this.constructor(this.id, this.fieldData["secondId"], this.fieldData["selectId"], this.validators, this.options, this.fieldData["values"], this.info, this.fieldData["fieldType"]);
  }

  /**
   * @inheritDoc
   */
  getIds(): string[] {
    return [this.id, this.fieldData["secondId"], this.fieldData["selectId"]];
  }
}
